import { ShieldWarning, CheckCircle, Hourglass } from "@phosphor-icons/react";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";

const fmt = (v) => (v == null ? "—" : Number(v).toLocaleString("en-IN", { maximumFractionDigits: 4 }));

// Oct 27 2026, user's spec point 4: these lines appear ONLY for a lot whose
// production model the Admin assigned Quality Activity to - the backend sends
// `row.quality` for nothing else, so every other lot's dialog is unchanged.
export const QualityNotice = ({ quality, sentToQuality, unit }) => {
  if (sentToQuality) {
    return (
      <Alert className="rounded-sm border-[#FEDF89] bg-[#FFFAEB]" data-testid="quality-sent-banner">
        <Hourglass size={16} />
        <AlertTitle className="font-heading text-sm">Sent to Quality · {sentToQuality.note_id}</AlertTitle>
        <AlertDescription className="font-sans text-[13px] break-words">{sentToQuality.message}</AlertDescription>
      </Alert>
    );
  }
  if (!quality?.quality_activity) return null;

  if (quality.blocked) {
    const why = quality.status === "rework"
      ? "Quality sent this lot for rework - it stays blocked until quality releases it."
      : quality.status === "hold"
        ? "Quality has put this lot on hold - it stays blocked until quality releases it."
        : "Quality has to accept the scrap before this lot can be confirmed.";
    return (
      <Alert variant="destructive" className="rounded-sm border-[#F04438]/40 bg-[#FEF3F2]" data-testid="quality-block-banner">
        <ShieldWarning size={16} />
        <AlertTitle className="font-heading text-sm">Quality Block · {quality.note_id}</AlertTitle>
        <AlertDescription className="font-sans text-[13px] break-words">
          {why}
          {quality.decision?.remark ? ` Quality's note: "${quality.decision.remark}"` : ""}
          {quality.requested ? ` (reported ${fmt(quality.requested.confirmed_scrap)} ${unit || ""} scrap)` : ""}
        </AlertDescription>
      </Alert>
    );
  }
  if (quality.status === "approved") {
    return (
      <Alert className="rounded-sm border-[#ABEFC6] bg-[#ECFDF3]" data-testid="quality-cleared-banner">
        <CheckCircle size={16} />
        <AlertTitle className="font-heading text-sm">Quality cleared · {quality.note_id}</AlertTitle>
        <AlertDescription className="font-sans text-[13px] break-words">
          Post {fmt(quality.decision?.physical_accepted_quantity)} good and{" "}
          {fmt(quality.decision?.approved_scrap_quantity)} scrap {unit || ""} - the figures quality accepted are filled in
          below and are the only ones SAP will take.
          {quality.decision?.remark ? ` Quality's note: "${quality.decision.remark}"` : ""}
        </AlertDescription>
      </Alert>
    );
  }
  return (
    <div className="text-[12px] text-[#475467] bg-[#F9FAFB] border border-[#EAECF0] rounded-sm px-2.5 py-1.5" data-testid="quality-activity-note">
      Quality Activity is on for this production model - scrap reported here goes to quality for a decision before it can
      be posted.
    </div>
  );
};
